import { BuildingRegulatoryInfoDTO, BuildingVolumePermitStatus, UnitsPermittedStatus } from "shared/types/regulatory-info";
import { API_URL } from "constants/index";
import { fetchWithAuth } from "shared/api/fetch-with-auth";
import { FileLabel } from "shared/types/file";
import { BuildingDTO } from "shared/types/building";

export const calculatePermitStatusDotValues = async (buildingRegulatoryInfo: BuildingRegulatoryInfoDTO, building: BuildingDTO, session: any) => {
    let dotValues: any = {
        red: { count: 0, labels: [] },
        orange: { count: 0, labels: [] },
        green: { count: 0, labels: [] },
        transparent: { count: 0, labels: [] },
    };

    // Handle the building volume permit status
    switch (buildingRegulatoryInfo?.buildingVolumePermitted) {
        case BuildingVolumePermitStatus.OK:
            dotValues.green.count++;
            dotValues.green.labels.push("Gebouw vergund");
            break;
        case BuildingVolumePermitStatus.NOT_REQUIRED:
            dotValues.green.count++;
            dotValues.green.labels.push("Gebouw vergund geacht");
            break;
        case BuildingVolumePermitStatus.PARTIAL:
            dotValues.orange.count++;
            dotValues.orange.labels.push("Gebouw gedeeltelijk vergund");
            break;
        case BuildingVolumePermitStatus.NOT_OK:
            dotValues.red.count++;
            dotValues.red.labels.push("Gebouw niet vergund");
            break;
        default:
            dotValues.transparent.count++;
            dotValues.transparent.labels.push("Gebouw vergund onbekend");
    }

    // Handle units permitted status
    switch (buildingRegulatoryInfo?.unitsPermitted) {
        case UnitsPermittedStatus.OK:
            dotValues.green.count++;
            dotValues.green.labels.push("Units allemaal vergund");
            break;
        case UnitsPermittedStatus.NOT_REQUIRED:
            dotValues.green.count++;
            dotValues.green.labels.push("Units vergund geacht");
            break;
        case UnitsPermittedStatus.PARTIAL:
            dotValues.orange.count++;
            dotValues.orange.labels.push("Units gedeeltelijk vergund");
            break;
        default:
            dotValues.transparent.count++;
            dotValues.transparent.labels.push("Units vergund onbekend");
    }

    // Fetch and check permit-related file logs
    try {
        const queryParams = new URLSearchParams();
        if (building?.id) {
            queryParams.append('buildingId', building.id);
        }

        const labels = [
            FileLabel.StedenbouwkundigeInlichtingen,
            "Watertoets",
            "Erfgoedinfo",
            "PV overtreding stedenbouw",
            FileLabel.Omgevingsvergunning,
            FileLabel.Milieuvergunning,
            FileLabel.ConformiteitsattestStedenbouw
        ];
        queryParams.append('labels', labels.join(','));

        const response = await fetchWithAuth(
            `${API_URL}/file/get-file-logs?${queryParams.toString()}`,
            { method: 'GET' },
            session
        );
        const fileLogs = await response.json();
        
        // Create a map to track which document types we've found
        const documentTypes = new Map();
        
        // Check for each permit document type
        fileLogs.forEach((log: any) => {
            const label = log.label;
            
            if (label.includes(FileLabel.StedenbouwkundigeInlichtingen) && !documentTypes.has(FileLabel.StedenbouwkundigeInlichtingen)) {
                dotValues.green.count++;
                dotValues.green.labels.push("Stedenbouwkundige inlichtingen aanwezig");
                documentTypes.set(FileLabel.StedenbouwkundigeInlichtingen, true);
            }
            
            if (label.includes("Watertoets") && !documentTypes.has("Watertoets")) {
                dotValues.green.count++;
                dotValues.green.labels.push("Watertoets aanwezig");
                documentTypes.set("Watertoets", true);
            }
            
            if (label.includes("Erfgoedinfo") && !documentTypes.has("Erfgoedinfo")) {
                dotValues.green.count++;
                dotValues.green.labels.push("Erfgoedinfo aanwezig");
                documentTypes.set("Erfgoedinfo", true);
            }
            
            if (label.includes("PV overtreding stedenbouw") && !documentTypes.has("PV overtreding stedenbouw")) {
                dotValues.green.count++;
                dotValues.green.labels.push("PV overtreding stedenbouw aanwezig");
                documentTypes.set("PV overtreding stedenbouw", true);
            }
            
            if (label.includes(FileLabel.Omgevingsvergunning) && !documentTypes.has(FileLabel.Omgevingsvergunning)) {
                dotValues.green.count++;
                dotValues.green.labels.push("Omgevingsvergunning aanwezig");
                documentTypes.set(FileLabel.Omgevingsvergunning, true);
            }
            
            if (label.includes(FileLabel.Milieuvergunning) && !documentTypes.has(FileLabel.Milieuvergunning)) {
                dotValues.green.count++;
                dotValues.green.labels.push("Milieuvergunning aanwezig");
                documentTypes.set(FileLabel.Milieuvergunning, true);
            }
            
            if (label.includes(FileLabel.ConformiteitsattestStedenbouw) && !documentTypes.has(FileLabel.ConformiteitsattestStedenbouw)) {
                dotValues.green.count++;
                dotValues.green.labels.push("Conformiteitsattest stedenbouw aanwezig");
                documentTypes.set(FileLabel.ConformiteitsattestStedenbouw, true);
            }
        });
        
    } catch (error) {
        console.error('Error fetching permit document logs:', error);
    }

    return dotValues;
};
